<template>
    <v-layout row wrap my-4
              :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
    >
        <v-flex v-for="(item, id) in content" :key="id" class="md4 sm6 xs12 mb-4"
                :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
        >
            <div class="db-card"
                 @click="modal_open_wrapper(item.database_id)"
            >
                {{ item.title }}
            </div>
        </v-flex>
        <!-- <listCardExtend class="md3" :class="{'mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}" /> -->
    </v-layout>
</template>

<script>
import listCardExtend   from '@/components/view_blocks/Database/list_blocks/list_card_extend';
import {mapGetters, mapMutations} from 'vuex';
export default {
  components: {
    listCardExtend,
  },
  props: {
    content: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters('database/modal', [
      'database_detail_modal',
      'current_detail',
    ]),
    ...mapGetters('database', [
      'current_tab',
    ]),
  },
  methods: {
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT',
    ]),
    modal_open_wrapper(database_id) {
      const url = window.location.href.split('?')[0] + '?modalId=' + database_id + '&tab=' + this.current_tab;
      window.history.pushState({}, 'DatabaseModal', url);

      let obj = {type: this.current_tab, id: database_id};

      this.OPEN_MODAL(this.database_detail_modal);
      this.SET_CURRENT(obj);
    },
  },
};
</script>

